import { REMOVE_TASK_PROP } from "../types";

export default (data: {
    taskIndex: number,
    removingProp: string,
}) => ({
    type: REMOVE_TASK_PROP,
    payload: data,
});
